export const EMAIL_OPTION = "email";
export const AUTHENTICATOR_OPTION = "authenticator";
